package fr.frux.feature.treedetail.identity

import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import fr.frux.core.designsystem.components.FruxButton
import fr.frux.core.designsystem.components.FruxNoteField
import fr.frux.core.designsystem.components.FruxTextField
import fr.frux.core.designsystem.error.userMessage
import fr.frux.feature.treedetail.resources.Res
import fr.frux.feature.treedetail.resources.treedetail_identity_sheet_note_label
import fr.frux.feature.treedetail.resources.treedetail_identity_sheet_note_placeholder
import fr.frux.feature.treedetail.resources.treedetail_identity_sheet_note_reason_label
import fr.frux.feature.treedetail.resources.treedetail_identity_sheet_note_reason_placeholder
import fr.frux.feature.treedetail.resources.treedetail_identity_sheet_note_title
import fr.frux.feature.treedetail.resources.treedetail_identity_sheet_save
import fr.frux.shared.content.DescriptionLength
import fr.frux.shared.content.TreeCorrectionLimits
import org.jetbrains.compose.resources.stringResource

/** Feuille « Modifier la note » (canvas `ModifierNote`). Une note vidée efface la note. */
@Composable
internal fun EditNoteSheet(
    sheet: IdentitySheet.Note,
    controller: TreeIdentityController,
) {
    IdentitySheetLayout(
        title = stringResource(Res.string.treedetail_identity_sheet_note_title),
        onClose = controller::dismissSheet,
        footer = {
            sheet.error?.let {
                Text(
                    text = it.userMessage(),
                    style = MaterialTheme.typography.bodySmall,
                    color = MaterialTheme.colorScheme.error,
                )
            }
            FruxButton(
                text = stringResource(Res.string.treedetail_identity_sheet_save),
                onClick = controller::saveNote,
                enabled = sheet.canSave,
                loading = sheet.saving,
                modifier = Modifier.fillMaxWidth(),
            )
        },
    ) {
        FruxNoteField(
            value = sheet.text,
            onValueChange = controller::onNoteChange,
            label = stringResource(Res.string.treedetail_identity_sheet_note_label),
            placeholder = stringResource(Res.string.treedetail_identity_sheet_note_placeholder),
            maxLength = DescriptionLength.MAX,
            showCounter = true,
            minLines = 5,
            labelStyle = MaterialTheme.typography.bodySmall,
        )
        FruxTextField(
            value = sheet.reason,
            onValueChange = controller::onNoteReasonChange,
            label = stringResource(Res.string.treedetail_identity_sheet_note_reason_label),
            placeholder = stringResource(Res.string.treedetail_identity_sheet_note_reason_placeholder),
            maxLength = TreeCorrectionLimits.REASON_MAX,
        )
    }
}
